import { jsx as _jsx } from "react/jsx-runtime";
import { useFormContext } from 'react-hook-form';
import { Size } from '@jetbrains/ring-ui/components/input/input';
import RegisteredSelect from '@app/common/hook-form/registered-select';
import { Required } from '@app/common/form/important-asterisk';
import { formatPluginSourceName } from '../../formatters';
const SOURCE_OPTIONS = [
    { key: 'MARKETPLACE', label: formatPluginSourceName('MARKETPLACE') },
    { key: 'TBE', label: formatPluginSourceName('TBE') }
];
function SourceField() {
    const { control, watch, setValue } = useFormContext();
    const watchSource = watch('source');
    const selectedSourceOption = SOURCE_OPTIONS.find(x => x.key === watchSource);
    const onChange = () => {
        setValue('pluginId', '');
        setValue('version', undefined);
    };
    return (_jsx(RegisteredSelect, { control: control, selectedLabel: Required('Source'), name: "source", data: SOURCE_OPTIONS, selected: selectedSourceOption, size: Size.L, changeListener: onChange }));
}
export default SourceField;
